<section class="card generate-card" aria-labelledby="generate-invoices-heading">
  <h2 id="generate-invoices-heading">Generate monthly partner invoices</h2>
  <p class="muted">
    Creates invoices for all partners for the selected calendar month (UTC billing
    period is returned in the summary).
  </p>

  <div *ngIf="errorMessage" class="alert alert-error" role="alert">
    {{ errorMessage }}
  </div>

  <div class="form-row">
    <div class="field">
      <label for="inv-year">Year</label>
      <select id="inv-year" [(ngModel)]="year" class="input" [disabled]="loading">
        <option *ngFor="let y of yearOptions" [ngValue]="y">{{ y }}</option>
      </select>
    </div>
    <div class="field">
      <label for="inv-month">Month</label>
      <select id="inv-month" [(ngModel)]="month" class="input" [disabled]="loading">
        <option *ngFor="let m of monthOptions" [ngValue]="m">
          {{ m | number: '2.0' }} — {{ monthNames[m - 1] }}
        </option>
      </select>
    </div>
    <div class="field field-action">
      <button
        type="button"
        class="btn-primary"
        (click)="generate()"
        [disabled]="loading">
        {{ loading ? 'Generating…' : 'Generate invoices' }}
      </button>
    </div>
  </div>

  <div *ngIf="result" class="result" role="status">
    <h3>Result</h3>
    <dl class="result-dl">
      <div>
        <dt>Invoices generated</dt>
        <dd>{{ result.invoicesGenerated }}</dd>
      </div>
      <div>
        <dt>Billing period (UTC calendar dates)</dt>
        <dd>
          {{ result.billingPeriodStartUtc | date: 'dd/MM/yyyy HH:mm':'UTC' }} —
          {{ result.billingPeriodEndUtc | date: 'dd/MM/yyyy HH:mm':'UTC' }}
        </dd>
      </div>
      <div>
        <dt>Year / month</dt>
        <dd>{{ result.year }} / {{ result.month }}</dd>
      </div>
    </dl>
  </div>
</section>
